<template>
    <span v-if="field === 'project_id'">
        <router-link v-if="item.project_id" :to="{ name: 'projects.show', params: { slug: item.project_id } }">
            {{ $filters.valueOrDefault(item.project_id) }}
        </router-link>
        <span v-else>{{ item.project_name }}</span>
    </span>
    <router-link v-else-if="field === 'company_id'" :to="{ name: 'companies.show', params: { slug: item.company_id } }">
        {{ $filters.valueOrDefault(item.company_name) }}
    </router-link>

    <span v-else-if="field === 'number'"><router-link :to="`/proposals/${item.id}`">{{ item.number }}</router-link></span>
    <span v-else-if="field === 'type'">{{ item.type }}</span>
    <span v-else-if="field === 'status'">{{ statusNameById(item.status) }}</span>
    <span v-else-if="field === 'contact_id'">{{ item.contact_name }}</span>
    <span v-else-if="field === 'address'">{{ item.address }}</span>
    <span v-else-if="field === 'borough'">{{ $filters.valueOrDefault(boroughNameById(item.borough)) }}</span>
    <span v-else-if="field === 'street'">{{ item.street }}</span>
    <span v-else-if="field === 'building'">{{ item.building }}</span>
    <span v-else-if="field === 'floor_number'">{{ item.floor_number }}</span>
    <span v-else-if="field === 'deposit_percent'">{{ item.deposit_percent }}</span>
    <span v-else-if="field === 'pay_in_full'">{{ $filters.yesNo(item.pay_in_full) }}</span>
    <router-link v-else-if="field === 'billed_to_company'" :to="{ name: 'companies.show', params: { slug: item.billed_to_company } }">
        {{ $filters.valueOrDefault(item.billed_to_company_name, '–') }}
    </router-link>
    <span v-else-if="field === 'billed_to_contact'">{{ $filters.valueOrDefault(item.billed_to_contact_name, '-') }}</span>
    <span v-else-if="field === 'sales_id'">{{ item.sales_id }}</span>
    <span v-else-if="field === 'permit_type'">{{ item.permit_type }}</span>
    <span v-else-if="field === 'work_type_id'">{{ $filters.valueOrDefault(workTypeNameById(item.work_type_id), '-') }}</span>
    <span v-else-if="field === 'terms_and_conditions'" class="terms-and-conditions" v-html="item.terms_and_conditions"></span>
    <span v-else-if="field === 'date_created'">{{ $filters.date(item.date_created) }}</span>
    <span v-else-if="field === 'sent_at'">{{ $filters.valueOrDefault($filters.datetime(item.sent_at), '–') }}</span>
    <span v-else-if="field === 'created_at'">{{ $filters.datetime(item.created_at ) }}</span>
    <span v-else-if="field === 'updated_at'">{{ $filters.datetime(item.updated_at ) }}</span>
    <span v-else-if="field === 'notable'"><o-icon v-if="item.notable" icon="check"></o-icon></span>
    <span v-else-if="field === 'project_type'">{{ projectTypeNameById(item.project_type) }}</span>
    <span v-else-if="item.created_by">
      <router-link v-if="field === 'created_by'" :to="{ name: 'users.show', params: { slug: item.created_by } }">
        {{ $filters.valueOrDefault(userNameById(item.created_by), '–') }}
    </router-link>
    </span>
    <router-link v-else-if="field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: item.last_editor_id } }">
        {{ userNameById(item.last_editor_id) }}
    </router-link>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {projectById} from "../../store/getters/projects";

    export default {
        props: ['item', 'field'],

        data(){
          return{
            project: {}
          }
        },
    
        computed: {
            ...mapGetters([
                'workTypeNameById',
                'boroughNameById',
                'userNameById',
                'projectTypeNameById'
            ])
        },
      methods:{
        ...mapActions(['fetchProjectById']),
         projectNameById(id){
            return this.fetchProjectById(id)
                .then(value => value.data.data)
                .then(value1 => value1)
          }
        },
    }
</script>
